import { useEffect, useState } from 'react'
import { Box, Heading, Text, Table, Thead, Tbody, Tr, Th, Td, Badge, Button, Input, HStack, Spinner, useToast } from '@chakra-ui/react'
import { Search } from 'lucide-react'
import axios from 'axios'

export default function AdminUsers() {
  const [users, setUsers] = useState([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const toast = useToast()

  useEffect(() => {
    setLoading(true)
    axios.get('/api/admin/users', { params: { page, limit: 20 } })
      .then(r => { setUsers(r.data.users); setTotal(r.data.total) })
      .finally(() => setLoading(false))
  }, [page])

  const toggleUser = async (id, isActive) => {
    await axios.patch('/api/admin/users/' + id, { is_active: !isActive })
    setUsers(prev => prev.map(u => u.id === id ? { ...u, is_active: !isActive } : u))
    toast({ title: 'User updated', status: 'success', duration: 2000 })
  }

  return (
    <Box p={8}>
      <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue" mb={2}>Users</Heading>
      <Text fontSize="14px" color="gray.500" mb={6}>{total} total users</Text>
      {loading ? <Spinner color="brand.orange" /> : (
        <Box bg="white" borderRadius="12px" border="1px solid #E2E2E2" overflow="hidden">
          <Table variant="simple" size="sm">
            <Thead bg="#F7F7F5">
              <Tr>
                <Th fontSize="11px" color="gray.500">Name</Th>
                <Th fontSize="11px" color="gray.500">Email</Th>
                <Th fontSize="11px" color="gray.500">Role</Th>
                <Th fontSize="11px" color="gray.500">Subscription</Th>
                <Th fontSize="11px" color="gray.500">Books</Th>
                <Th fontSize="11px" color="gray.500">Status</Th>
                <Th fontSize="11px" color="gray.500">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {users.map(u => (
                <Tr key={u.id} _hover={{ bg: '#F7F7F5' }}>
                  <Td fontSize="13px" fontWeight="500" color="brand.darkBlue">{u.full_name}</Td>
                  <Td fontSize="12px" color="gray.600">{u.email}</Td>
                  <Td><Badge fontSize="10px" px={2} bg="#0A1F4415" color="brand.darkBlue" borderRadius="4px">{u.role}</Badge></Td>
                  <Td>
                    {u.has_subscription
                      ? <Badge fontSize="10px" px={2} bg="#1A6B2A15" color="#1A6B2A" borderRadius="4px">{u.subscription_plan}</Badge>
                      : <Text fontSize="12px" color="gray.400">None</Text>}
                  </Td>
                  <Td fontSize="13px" color="gray.600">{u.book_count}</Td>
                  <Td><Badge fontSize="10px" px={2} bg={u.is_active ? '#1A6B2A15' : '#CC000015'} color={u.is_active ? '#1A6B2A' : '#CC0000'} borderRadius="4px">{u.is_active ? 'Active' : 'Inactive'}</Badge></Td>
                  <Td><Button size="xs" variant="ghost" color={u.is_active ? 'red.400' : 'green.500'} onClick={() => toggleUser(u.id, u.is_active)}>{u.is_active ? 'Deactivate' : 'Activate'}</Button></Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
      <HStack justify="center" mt={4} spacing={3}>
        <Button size="sm" variant="outline" isDisabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</Button>
        <Text fontSize="13px" color="gray.500">Page {page}</Text>
        <Button size="sm" variant="outline" onClick={() => setPage(p => p + 1)}>Next</Button>
      </HStack>
    </Box>
  )
}
